/**
 * The switch for the tenancy hints.
 *
 * The scope pills — where the next attach lands, which tier the chips around it
 * resolved at, who else can see this catalog row — are the answer to "why can't
 * I see the label I just added?", so they are on by default. But they are also
 * the kind of affordance a product decides about later: too advanced for a
 * self-serve tier, redundant for a single-user tenant, or something an
 * enterprise wants replaced with its own wording.
 *
 * One flag, read in one place (`ui-core`'s `HintPill`), so that decision is a
 * config change rather than a hunt through every surface that grew a pill. The
 * NAME is shared with the packages — a flag the dashboard declared privately
 * would leave the admin portal's identical pills answering to nothing — and it
 * rides the normal flag precedence: a local override beats the tenant's
 * `feature_flags` JWT claim, which beats the default registered below.
 */
import type { FlagMap } from "@authe/fe-commons/flags";
import { SCOPE_HINT_FLAG } from "@authe/fe-commons/attribution";

/** Show the tenancy scope pills (write target, read tier, catalog row scope). */
export { SCOPE_HINT_FLAG };

/**
 * Build-time defaults for the UI flags.
 *
 * Registered explicitly because `FeatureFlags.isEnabled` answers `false` for a
 * name it has never heard of: an unregistered flag would not read as "no opinion
 * yet", it would silently hide the pills everywhere.
 */
export function uiFlagDefaults(): FlagMap {
  return { [SCOPE_HINT_FLAG]: true };
}
